import React from 'react'

import { Helmet } from 'react-helmet'

import './specificarticle.css'

const Specificarticle = (props) => {
  return (
    <div className="specificarticle-container1">
      <Helmet>
        <title>specificarticle - exported project</title>
        <meta
          property="og:title"
          content="specificarticle - exported project"
        />
        <link
          rel="canonical"
          href="https://polipatch-copy-ycxznx.teleporthq.app/specificarticle"
        />
        <meta
          property="og:url"
          content="https://polipatch-copy-ycxznx.teleporthq.app/specificarticle"
        />
      </Helmet>
      <div className="specificarticle-thq-specificarticle-elm">
        <img
          src="/ellipse32104-k4ej-200h.png"
          alt="Ellipse32104"
          className="specificarticle-thq-ellipse3-elm"
        />
        <div className="specificarticle-thq-maskgroup-elm">
          <img
            src="/ellipse12104-9ctk-200h.png"
            alt="Ellipse12104"
            className="specificarticle-thq-ellipse1-elm"
          />
          <img
            src="/ellipse22104-fut8.svg"
            alt="Ellipse22104"
            className="specificarticle-thq-ellipse2-elm"
          />
        </div>
        <img
          src="/ellipse42104-ptum-200h.png"
          alt="Ellipse42104"
          className="specificarticle-thq-ellipse4-elm"
        />
        <span className="specificarticle-thq-text-elm10">Volunteer</span>
        <span className="specificarticle-thq-text-elm11">Articles</span>
        <span className="specificarticle-thq-text-elm12">Debates</span>
        <span className="specificarticle-thq-text-elm13">Sources</span>
        <span className="specificarticle-thq-text-elm14">About Us</span>
        <div className="specificarticle-thq-frame5-elm">
          <span className="specificarticle-thq-text-elm15">Home</span>
        </div>
        <img
          src="/tempimagelqgknm22119-ysxw-900h.png"
          alt="tempImagelqgKnm22119"
          className="specificarticle-thq-temp-imagelqg-knm2-elm"
        />
        <span className="specificarticle-thq-text-elm16">
          Specific Title
          <span
            dangerouslySetInnerHTML={{
              __html: ' ',
            }}
          />
        </span>
        <span className="specificarticle-thq-text-elm17">By: Author Name</span>
        <span className="specificarticle-thq-text-elm18">
          <span>
            Lorem ipsum dolor sit amet consectetur. Nam sollicitudin etiam
            bibendum fringilla blandit. Ornare venenatis felis sit est turpis.
            Dignissim dictum id vestibulum felis arcu posuere. Consectetur
            pellentesque proin odio quisque risus sit quis semper dui. In
            pretium lacus risus risus commodo etiam eros sit iaculis. Dignissim
            quisque ut commodo pellentesque nisl ut pellentesque odio lectus. Mi
            in odio congue aliquam purus. Imperdiet volutpat diam commodo nunc.
            Eleifend dignissim tristique eget nulla cursus in vel urna. Vel
            ultrices morbi nibh mollis lacus in magna arcu. Egestas vulputate
            tincidunt velit nunc lectus. Amet tellus ut ut tincidunt bibendum
            augue in. Et magna vitae aenean sagittis. Ac sed feugiat velit
            vestibulum at mattis. Feugiat ultricies pharetra quis tellus. Odio
            morbi duis enim habitant phasellus lobortis. Consequat tempor massa
            velit amet blandit pretium erat amet. Dolor gravida enim
            pellentesque ut quis ut lectus fermentum dignissim. Eget libero
            tincidunt leo tincidunt. Nunc sed mauris blandit turpis cursus.
            Imperdiet pulvinar aliquet ut cursus. Nascetur enim nunc elementum
            turpis dui nibh. Sem nisl sed risus auctor ut sodales lectus.
            Feugiat nibh in nisl in ut scelerisque diam aliquam. Amet magnis sit
            vulputate in euismod montes malesuada erat nisi. Lectus facilisis
            facilisis nunc turpis vulputate. Nec risus nisi auctor orci etiam eu
            imperdiet tristique felis. Faucibus non amet sollicitudin sodales
            sit sit. Velit vitae aenean viverra dictum imperdiet eget neque.
          </span>
          <br></br>
          <br></br>
          <span>
            Lorem ipsum dolor sit amet consectetur. Nam sollicitudin etiam
            bibendum fringilla blandit. Ornare venenatis felis sit est turpis.
            Dignissim dictum id vestibulum felis arcu posuere. Consectetur
            pellentesque proin odio quisque risus sit quis semper dui. In
            pretium lacus risus risus commodo etiam eros sit iaculis. Dignissim
            quisque ut commodo pellentesque nisl ut pellentesque odio lectus. Mi
            in odio congue aliquam purus. Imperdiet volutpat diam commodo nunc.
            Eleifend dignissim tristique eget nulla cursus in vel urna. Vel
            ultrices morbi nibh mollis lacus in magna arcu. Egestas vulputate
            tincidunt velit nunc lectus. Amet tellus ut ut tincidunt bibendum
            augue in. Et magna vitae aenean sagittis. Ac sed feugiat velit
            vestibulum at mattis. Feugiat ultricies pharetra quis tellus. Odio
            morbi duis enim habitant phasellus lobortis. Consequat tempor massa
            velit amet blandit pretium erat amet. Dolor gravida enim
            pellentesque ut quis ut lectus fermentum dignissim. Eget libero
            tincidunt leo tincidunt. Nunc sed mauris blandit turpis cursus.
            Imperdiet pulvinar aliquet ut cursus. Nascetur enim nunc elementum
            turpis dui nibh. Sem nisl sed risus auctor ut sodales lectus.
            Feugiat nibh in nisl in ut scelerisque diam aliquam. Amet magnis sit
            vulputate in euismod montes malesuada erat nisi. Lectus facilisis
            facilisis nunc turpis vulputate. Nec risus nisi auctor orci etiam eu
            imperdiet tristique felis. Faucibus non amet sollicitudin sodales
            sit sit. Velit vitae aenean viverra dictum imperdiet eget neque.
          </span>
        </span>
        <span className="specificarticle-thq-text-elm21">
          View more articles
        </span>
      </div>
      <a
        href="https://play.teleporthq.io/signup"
        className="specificarticle-link"
      >
        <div
          aria-label="Sign up to TeleportHQ"
          className="specificarticle-container2"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 19 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="specificarticle-icon1"
          >
            <path
              d="M9.1017 4.64355H2.17867C0.711684 4.64355 -0.477539 5.79975 -0.477539 7.22599V13.9567C-0.477539 15.3829 0.711684 16.5391 2.17867 16.5391H9.1017C10.5687 16.5391 11.7579 15.3829 11.7579 13.9567V7.22599C11.7579 5.79975 10.5687 4.64355 9.1017 4.64355Z"
              fill="#B23ADE"
            ></path>
            <path
              d="M10.9733 12.7878C14.4208 12.7878 17.2156 10.0706 17.2156 6.71886C17.2156 3.3671 14.4208 0.649963 10.9733 0.649963C7.52573 0.649963 4.73096 3.3671 4.73096 6.71886C4.73096 10.0706 7.52573 12.7878 10.9733 12.7878Z"
              fill="#FF5C5C"
            ></path>
            <path
              d="M17.7373 13.3654C19.1497 14.1588 19.1497 15.4634 17.7373 16.2493L10.0865 20.5387C8.67402 21.332 7.51855 20.6836 7.51855 19.0968V10.5141C7.51855 8.92916 8.67402 8.2807 10.0865 9.07221L17.7373 13.3654Z"
              fill="#2874DE"
            ></path>
          </svg>
          <span className="specificarticle-text3">Built in TeleportHQ</span>
        </div>
      </a>
    </div>
  )
}

export default Specificarticle
